<template>
  <div :style="$cmsStyles('c_2dc54a20fa4a')">
    <tools-bar ref="toolsBar" @backtop="onBacktop"></tools-bar>
    <consult-phone ref="consultPhone"></consult-phone>
    <consult-modal ref="consultModal" @phoneConsult="showConsultPhone"></consult-modal>
    <p-header type="flow" ref="header"></p-header>
    <video-section></video-section>
    <div class="footer">
      <p-footer type="flow" theme="transparent"></p-footer>
    </div>
  </div>
</template>

<script>
import Header from '../layout/Header.vue'
import ToolsBar from '@/components/ToolsBar.vue'
import ConsultPhone from '@/components/ConsultPhone.vue'
import ConsultModal from '@/components/ConsultModal.vue'
import VideoSection from '@/components/home/VideoSection.vue'
import Footer from '../layout/Footer.vue'
// import PanelsSection from '@/components/home/PanelsSection.vue'
// import DataSection from '@/components/home/DataSection.vue'
// import AnchorSection from '@/components/home/AnchorSection.vue'
// import StoreSection from '@/components/home/StoreSection.vue'
// import JoinSection from '@/components/home/JoinSection.vue'

export default {
  name: "Home",
  head() { return this.$cmsHead('c_2dc54a20fa4a', {
    title: '魔筷科技-专注家庭健康生活的全球化品牌集团|主播带货|直播电商',
    meta: [
      {
        name: 'Keywords',
        content: '魔筷科技,直播电商,主播带货,品牌集团,家庭健康,大嘴鳄,合味芳,露小白,百谜,全域增长,直播基地,供应链,快手,抖音,视频号,小红书'
      },
      {
        name: 'Description',
        content: '魔筷科技是专注家庭健康生活的全球化品牌集团，提供专业的直播电商全链路解决方案。拥有全网70万中小主播分销网络，旗下合味芳、大嘴鳄、露小白、百谜等知名品牌，为品牌方提供全域增长新引擎，覆盖全产业链价值赋能。'
      }
    ]
  }); },
  components: {
    'p-header': Header,
    ToolsBar,
    ConsultPhone,
    ConsultModal,
    VideoSection,
    'p-footer': Footer,
    // PanelsSection,
    // DataSection,
    // AnchorSection,
    // StoreSection,
    // JoinSection
  },
  data() {
    return {
      lastScrollTop: 0,
      animationId: null,
      isScrolling: false,
      scrollHandler: null, // 滚动事件处理器
    }
  },
  beforeMount() {
    this.$bus.$emit('headerModeChange', 'transparent')
  },
  mounted() {
    localStorage.removeItem('currentSection')
    this.$refs.toolsBar.hide()
    this.initScrollListener()
  },
  destroyed() {
    this.removeScrollListener()
  },
  methods: {
    showModal() {
      console.log(this.$refs.consultModal)
      this.$refs.consultModal.show()
    },
    closeModal() {
      this.$refs.consultModal.close()
    },
    onContainerClick() {
      this.closeConsultPhone()
    },
    showConsultPhone() {
      this.$refs.consultPhone.show()
    },
    closeConsultPhone() {
      this.$refs.consultPhone.close()
    },
    onBacktop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    
    // 初始化滚动监听器
    initScrollListener() {
      this.scrollHandler = this.throttle(this.handleScroll, 16) // 约60fps
      window.addEventListener('scroll', this.scrollHandler, { passive: true })
    },
    
    // 移除滚动监听器
    removeScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler)
        this.scrollHandler = null
      }
    },
    
    // 处理滚动事件
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollTop > 100) {
        // 示例：显示工具栏
        if (this.$refs.toolsBar) {
          this.$refs.toolsBar.show()
        }
        
        // 示例：改变header模式
        this.$bus.$emit('headerModeChange', 'normal')
      } else {
        if (this.$refs.toolsBar) {
          this.$refs.toolsBar.hide()
        }
        
        // 示例：改变header模式为透明
        this.$bus.$emit('headerModeChange', 'transparent')
      }
    },
    
    // 节流函数 - 优化滚动性能
    throttle(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func.apply(this, args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.hide {
  display: none;
}
.footer {
  background: #00092a;
}
.section {
  position: relative;
  &:nth-child(1) {
    // background-color: rgba(0, 9, 42, .3);
    background-color: transparent;
    
  }
  &:nth-child(2) {
    background-color: #fff;
  }
  &:nth-child(3) {
    background-color: #00092a;
  }
  &:nth-child(4) {
    background-color: #fff;
  }
  &:nth-child(5) {
    background-color: rgba(0, 9, 42, 1);
  }
  &:nth-child(6) {
    // height: 200vh!important;
  }

  &.wrap-saas {
    background-image: var(--cms-c_2dc54a20fa4a-f_0001, url("https://mktv-in-cdn.mockuai.com/16238093980913802.png"));
  }
  &.wrap-supply {
    background-image: var(--cms-c_2dc54a20fa4a-f_0002, url("https://mktv-in-cdn.mockuai.com/16238152069838910.png"));
  }
  &.wrap-anchor {
    background-image: var(--cms-c_2dc54a20fa4a-f_0003, url("https://mktv-in-cdn.mockuai.com/16238149059689781.png"));
  }
  &.wrap-data {
    background-image: var(--cms-c_2dc54a20fa4a-f_0004, url("https://mktv-in-cdn.mockuai.com/16238154825288660.png"));
  }
}
.pt-90 {
  padding-top: 90px; 
}
</style>
